'use client'

import type { FilterButtonProps } from '@pearlconvert/ui/components/button/button.types'

import classNames from 'classnames'
import React from 'react'

import { useFilterButton } from '@pearlconvert/ui/components/button/batons/use-filter-button'

const FilterButton: React.FC<FilterButtonProps> = ({
  children,
  title,
  size = 'normal',
  isLoading = false,
  icon,
  disabled,
  inactive,
  className,
  onClick,
  testId,
}: FilterButtonProps) => {
  const buttonClass = classNames('button', 'button__filter', {
    [`button__${size}`]: size,
    button__loading: isLoading,
    [`button__iconLeft--${icon}`]: icon,
    'button__button--has-icons': icon,
    [`button__${className}`]: className,
  })

  const { expanded, handleClick } = useFilterButton({ onClick })

  return (
    <button
      title={title}
      className={buttonClass}
      disabled={disabled}
      aria-disabled={disabled || inactive}
      aria-label={title}
      aria-expanded={expanded}
      data-testid={testId}
      onClick={handleClick}
    >
      <span className="button__text">{children}</span>
    </button>
  )
}

export default FilterButton
